
export default function WhySpecialist() {
  return (
    <section className="py-20 px-6 bg-[#0e0d0b]">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-[#f5f5f0] mb-6 text-center">
          Why Use a Specialist?
        </h2>
        <p className="text-[#d4d4ce] text-base leading-relaxed text-center mb-10">
          Pianos weigh between 90kg and 600kg. They contain thousands of fragile components. Moving a piano incorrectly can cause irreparable damage worth thousands of pounds. Always use a <strong className="text-[#c9a84c]">specialist piano removal company</strong> — not a general removals firm or man-and-van service. Professional piano movers have the right equipment, training and insurance to protect your valuable instrument during transit.
        </p>
        <div className="w-full h-80 rounded-lg overflow-hidden">
          <img
            src="https://ik.imagekit.io/pianomoverslondon/Piano%20movers%20home%20page/piano-transport-lift-craine-piano-in-london_orig.jpg/tr:w-600,h-440,c-at_max,q-80,f-webp"
            alt="Piano removal specialists London — wrapping piano for safe transport"
            title="Piano Removal Specialists London — Safe Professional Transport"
            width="800"
            height="500"
            loading="lazy"
            decoding="async"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}
